import type { CommunityMember } from "@circle-react/types/CommunityMember";
import type { Reply } from "./Reply";

export const QUESTION_STATUSES = {
  APPROVED: "approved",
  ANSWERED: "answered",
  UNANSWERED: "unanswered",
  PENDING: "pending",
  DISMISSED: "dismissed",
} as const;

export type QuestionStatus =
  (typeof QUESTION_STATUSES)[keyof typeof QUESTION_STATUSES];

export interface MinimalContact {
  avatar_url?: string | null;
  id: number;
  name: string;
  public_uid: string;
}

export interface Question {
  approved_at?: string | null;
  body: {
    body: object;
    attachments: any[];
  };
  community_member?: CommunityMember;
  contact?: MinimalContact | null;
  contact_type?: string | null;
  created_at: string;
  id: number;
  last_reply?: Reply | null;
  pinned_reply?: Reply | null;
  replies_count: number;
  spotlighted: boolean;
  status: QuestionStatus;
  upvoted_by_current_community_member: boolean;
  upvotes_count: number;
}
